export default __webpack_public_path__ + "static/media/nu.3fd09351.jpg";